module.exports = __webpack_public_path__ + "img/arrow.bdf66bb2.svg";